// File: app.module.ts
// Author: Joseph M Diaz
// Date: 4/20/2017
// Desc: Root module for the app.
// Other Contributors: Brandon Shreve

// 3rd Party
//
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

// Modules
//
import { CgpModule } from './cgp.module';
import { AppRoutingModule } from './app.routing';
import { ApiModule } from '../modules/api';
import { TprecmModule } from '../app/components/tprecm/tprecm.module';
import { CgpBroadcastMessageModule } from 'cgp-broadcast-message';

// Components
//
import { AppComponent } from './app.component';
import { AppService } from './app.service';
import { HomeComponent } from './home/home.component';
import { LoggedOutComponent } from './logged-out/logged-out.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { NotYetImplementedComponent } from './not-yet-implemented/not-yet-implemented.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';

// Services
//
import { UserService } from '../modules/user.service';
import { FileDownloadService } from './shared/file-download/file-download.service';
import { BaseHttpService } from './shared/base-http/base-http.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DialogDraggableHeaderModule } from './shared/dialog-draggable-header/dialog-draggable-header.module';
import { DataTableModule } from './shared/data-table/data-table.module';
import { HttpDateUTCInterceptorService } from './shared/http-date-utc-interceptor/http-date-utc-interceptor.service';

@NgModule({
   imports: [
      BrowserModule,
      BrowserAnimationsModule,
      AppRoutingModule,
      HttpClientModule,
      ToastrModule,
      MatProgressSpinnerModule,
      MatToolbarModule,
      MatTooltipModule,
      MatSortModule,
      MatSidenavModule,
      MatMenuModule,
      MatButtonModule,
      MatIconModule,
      MatInputModule,
      MatRadioModule,
      CgpModule,
      ApiModule,
      TprecmModule,
      DialogDraggableHeaderModule,
      DataTableModule,
      CgpBroadcastMessageModule
   ],
   declarations: [
      AppComponent,
      HomeComponent,
      LoggedOutComponent,
      NotFoundComponent,
      NotYetImplementedComponent,
      AccessDeniedComponent
   ],
   providers: [
      AppService,
      UserService,
      FileDownloadService,
      BaseHttpService,
      {
         provide: HTTP_INTERCEPTORS,
         useClass: HttpDateUTCInterceptorService,
         multi: true
      }
   ],
   bootstrap: [AppComponent]
})
export class AppModule { }
